import { IFilterOptions } from '@quadminds/shared/commons';

export interface IGetTripsDefinitionsFiltersDto extends IFilterOptions {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
